import useOrders from "~/composables/user/useOrders";
import paths from "~/constants/paths";

export default defineNuxtRouteMiddleware((to) => {
  const { selectedOrder } = useOrders();

  if (to.path === paths.account.orders.details && !selectedOrder.value) {
    return navigateTo(paths.account.orders.active);
  }
});
